import { ANNOTATION_SOURCE_LOCATION, parseLocationRef } from '@backstage/catalog-model';

function getEntitySourceLocation(entity, scmIntegrationsApi) {
  const sourceLocation = entity.metadata.annotations?.[ANNOTATION_SOURCE_LOCATION];
  if (!sourceLocation) {
    return void 0;
  }
  try {
    const sourceLocationRef = parseLocationRef(sourceLocation);
    const integration = scmIntegrationsApi.byUrl(sourceLocationRef.target);
    return {
      locationTargetUrl: sourceLocationRef.target,
      integrationType: integration?.type
    };
  } catch {
    return void 0;
  }
}

export { getEntitySourceLocation };
//# sourceMappingURL=getEntitySourceLocation.esm.js.map
